export const patternStoryExchange = () => {
  const innerBlocks = document.querySelectorAll(
    '.pattern-story-exchange .wp-block-group'
  );

  const isMobile = window.matchMedia('(max-width: 781px)').matches;
  let offset = isMobile ? 300 : 0;
  let half = (window.innerHeight + offset) / 2;

  window.addEventListener('resize', () => {
    const isMobile = window.matchMedia('(max-width: 781px)').matches;
    offset = isMobile ? 300 : 0;
    half = (window.innerHeight + offset) / 2;
  });

  // on window scroll
  window.addEventListener('scroll', () => {
    for (const [i, block] of innerBlocks.entries()) {
      // get bounds of wrapping div instead, paragraphs will get fixed position
      const bounds = block.getBoundingClientRect();
      const { top, bottom, height } = bounds;
      const middle = top + height / 2;

      let opacity = 1;

      if (middle - 5 <= half && middle + 5 >= half) {
        opacity = 1;
      } else if (top > half) {
        opacity = 1 + (half - top) / (half - offset - height);
      } else if (bottom < half) {
        opacity = (top - offset) / (half - offset - height);
      }

      block.style.opacity = opacity > 1 ? 1 : opacity < 0 ? 0 : opacity;
    }
  });
};
